import { useEffect, useRef } from 'react'

/*

Vedi 2° risposta a https://stackoverflow.com/questions/57476683/setinterval-is-not-showing-updated-state

spiegazione completa: https://overreacted.io/making-setinterval-declarative-with-react-hooks/

*/

export const useInterval = (callback, delay) => {
  const savedCallback = useRef()

  useEffect(() => {
    savedCallback.current = callback
  })

  useEffect(() => {
    function tick() {
      savedCallback.current()
    }

    let id = setInterval(tick, delay)
    return () => clearInterval(id)
  }, [delay])
}
